export const isHandleRegime = (business) => {
    if (
        business.info &&
        business.info.handle_regime &&
        business.info.handle_regime === 1
    ) {
        return true;
    }
    return false;
};

export default isHandleRegime;
